module.exports = __webpack_public_path__ + "img/img-avatar06.e5b4d21d.jpg";